import { colors } from '@/src/theme/colors';
import { formatDate } from '@/src/utils/dates';

export type IdentityMetadataLabelItem = {
  label: string | null | undefined;
};

export function identityInitial(fullName: string | null | undefined) {
  return (fullName?.trim() || 'Frienzzi user').slice(0, 1).toUpperCase();
}

export function identityMetadataLabels({
  metadataItems = [],
  metadataLabels = [],
  timestampLabel,
  username,
}: {
  metadataItems?: IdentityMetadataLabelItem[];
  metadataLabels?: string[];
  timestampLabel?: string | null;
  username?: string | null;
}) {
  return [
    username ? `@${username}` : null,
    timestampLabel || null,
    ...metadataLabels,
    ...metadataItems.map((item) => item.label),
  ].filter((label): label is string => Boolean(label));
}

export function identityUsernameColor({
  overlay = false,
}: {
  overlay?: boolean;
} = {}) {
  return overlay ? 'rgba(255,255,255,0.82)' : colors.primary;
}

export function identityVerificationLabel(verified?: boolean | null) {
  if (verified === true) {
    return 'verified account';
  }

  if (verified === false) {
    return 'unverified account';
  }

  return null;
}

export function resolveIdentityBadge({
  fallback,
  live,
  loadingLiveProfile,
}: {
  fallback?: boolean | null;
  live?: boolean | null;
  loadingLiveProfile?: boolean;
}) {
  if (typeof live === 'boolean') {
    return live;
  }

  if (loadingLiveProfile) {
    return null;
  }

  return typeof fallback === 'boolean' ? fallback : null;
}

export function identityAccessibilityLabel({
  founderBadge,
  fullName,
  metadataItems,
  timestamp,
  username,
  verifiedBadge,
}: {
  founderBadge?: boolean | null;
  fullName: string | null | undefined;
  metadataItems?: IdentityMetadataLabelItem[];
  timestamp?: unknown;
  username?: string | null;
  verifiedBadge?: boolean | null;
}) {
  const displayName = fullName?.trim() || 'Frienzzi user';
  const verification = identityVerificationLabel(verifiedBadge);
  const labels = identityMetadataLabels({
    metadataItems,
    timestampLabel: timestamp ? formatDate(timestamp) : null,
    username,
  });

  return [
    displayName,
    verification,
    founderBadge === true ? 'founder' : null,
    ...labels,
  ]
    .filter((label): label is string => Boolean(label))
    .join(', ');
}
